import { useAuth } from "contexts/AuthContext";

export function useProfilePicture() {
    const { user } = useAuth();

    const rawUrl = user?.profilePictureUrl;
    const baseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
    const prefix = `${baseUrl}/api/media/image?src=`;
    const actualUrl = rawUrl?.replace(prefix, "");
    
    const hasProfilePicture = Boolean(actualUrl !== null && actualUrl !== undefined && actualUrl !== "");

    return { rawUrl, actualUrl, hasProfilePicture };
}